<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width" [class.toolbar-empty]="!absi">
        <!-- Bug 6961: below md show the page title only while no record is open, so the header stays compact once one is -->
        <div class="col-md-3 d-print-none d-none d-md-flex align-items-center" [ngClass]="{ 'd-flex': !absi }">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <!-- Bug 6961: sit beside the Type and Created Date fields from sm up -->
        <div
          class="col-12 col-sm-4 col-md-3 d-flex align-items-start flex-column justify-content-center"
          *ngIf="!isCreating"
        >
          <h1 [ngClass]="absi?.formStatus?.color">
            <span id="serialNumber">{{ absi?.serialNo }}</span>
            <span class="ml-1 small" *ngIf="absi"
              >for {{ absi.resourceName }}</span
            >
          </h1>
          <span *ngIf="absi" class="status" [ngClass]="absi.formStatus?.color">
            {{ absi.formStatus?.name }}
            <span *ngIf="absi.status == formStatusEnum.Canceled" class="red"
              >by <b class="red">{{ absi.updatedByName }}</b> on
              {{ absi.updatedOn | date }}</span
            >
          </span>
        </div>
        <!-- Bug 6961: share one row with Type on phones and with Type and Created Date from sm up -->
        <div
          class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center"
          *ngIf="isCreating"
        >
          <mat-form-field>
            <mat-label>Schedule</mat-label>
            <input
              #input
              type="text"
              placeholder="Select Schedule"
              matInput
              [matAutocomplete]="autoSchedule"
              (input)="filterSchedules($event)"
              [(ngModel)]="schedule"
            />
            <mat-autocomplete
              requireSelection
              #autoSchedule="matAutocomplete"
              [displayWith]="displayObject"
              (optionSelected)="onScheduleSelected($event)"
            >
              <mat-option
                [ngClass]="{
                  'bold blue': !schedule.disabled,
                  disabled: schedule.disabled,
                }"
                *ngFor="let schedule of schedulesFiltered"
                [value]="schedule"
                [disabled]="schedule.disabled"
              >
                {{ schedule.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <!-- Bug 6961: share one row with Created Date on phones, and with the serial number from sm up -->
        <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" *ngIf="absi && !isCreating">
            <mat-label>Type</mat-label>
            <input
              aria-label="type"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="absi.typeName"
              disabled
            />
            <mat-hint>{{ absi.versionName }}</mat-hint>
          </mat-form-field>
          <mat-form-field *ngIf="isCreating">
            <mat-label>Type</mat-label>
            <input
              #input
              type="text"
              placeholder="Select Template Type"
              matInput
              [matAutocomplete]="autoAbsiTemplateType"
              (input)="filterAbsiTemplateTypes($event)"
              [(ngModel)]="absiTemplateType"
            />
            <mat-autocomplete
              requireSelection
              #autoAbsiTemplateType="matAutocomplete"
              [displayWith]="displayObject"
              (optionSelected)="onAbsiTemplateTypeSelected($event)"
            >
              <mat-option
                *ngFor="let absiTemplateType of absiTemplateTypesFiltered"
                [value]="absiTemplateType"
                >{{ absiTemplateType.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-hint>{{ absi?.versionName }}</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
          <mat-form-field appearance="outline" *ngIf="absi">
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(absi.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex align-items-center justify-content-end"
        >
          <div *ngIf="isCreating && hasPrivilege(privilegeEnum.CreateABSI)">
            <button
              mat-flat-button
              color="accent"
              (click)="createNew()"
              [disabled]="!schedule || !absiTemplateType"
            >
              Create
            </button>
            <button
              class="ml-2"
              mat-stroked-button
              color="warn"
              (click)="cancelNew()"
            >
              Cancel
            </button>
          </div>
          <div *ngIf="!isCreating">
            <button
              mat-flat-button
              color="warn"
              *ngIf="
                (absi?.status == formStatusEnum.Active ||
                  absi?.status == formStatusEnum.Draft) &&
                hasPrivilege(privilegeEnum.CancelABSIChecklist)
              "
              (click)="cancel()"
            >
              Cancel
            </button>
            <span
              class="red wrap"
              *ngIf="
                absi?.status == formStatusEnum.Canceled && absi?.cancelReason
              "
            >
              Cancel Reason: <b class="red">{{ absi?.cancelReason }}</b>
            </span>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list class="pb-0">
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <absi-side-panel
              [filter]="filter"
              (rowSelected)="rowSelected($event)"
              id="sidePanel"
              #sidePanel
            ></absi-side-panel>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons" class="pt-0">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.CreateABSI)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="catlReport()"
          class="parent"
          *ngIf="absi && !isCreating"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >CATL Report</span
          >
          <mat-icon matListItemIcon class="blue">summarize</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="commentsSummary()"
          class="parent"
          *ngIf="absi && !isCreating"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Comments & Recommendations</span
          >
          <mat-icon matListItemIcon class="blue">feedback</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: false,
          }"
        >
          <absi-main-panel
            [absi]="absi"
            *ngIf="absi?.wfTable"
          ></absi-main-panel>
          <!-- Main Content Here -->
        </div>
        <div class="buttons d-print-none" id="sidenav-content-buttons"></div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
